<div #scrollContainer class="field-padding-overall form-container">
  <div class="form-section">
    <div>
      <h1 class="heading-text heading-name">Transload Vendor Registration</h1>
      <p class="sub-heading-text">
        Join the Loup transload network — register today.
      </p>
    </div>

    <form [formGroup]="vendorRegistrationForm">
      <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column" >
        <div fxFlex class="max-width first-row-field-width">
          <lib-text-field-alls #legalCompanyName [isSubmitted]="isSubmitted" [errorMessage]="legalCompany+isRequired"
            [fullWidth]="true" [fieldLabel]="legalCompany" [placeholder]="'ABCD'" [fieldLength]="100" 
            [fieldName]="legalCompany" [alignmentRight]="false" [required]="true" [formControlData]="vendorRegistrationForm"
            (inputFieldData)="fieldValue($event, 'legalCompanyName')">
          </lib-text-field-alls>
        </div>

        <div fxFlex class="max-width first-row-field-width">
          <lib-text-field-alls #businessNameDba [isSubmitted]="isSubmitted" [errorMessage]="businessName+isRequired"
            [fullWidth]="true" [fieldLabel]="businessName" [placeholder]="'ABCD'" [fieldLength]="100" 
            [fieldName]="businessName" [alignmentRight]="false" [required]="true" [formControlData]="vendorRegistrationForm"
            (inputFieldData)="fieldValue($event, 'businessName')"
          ></lib-text-field-alls>
        </div>
      </div>

      <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column">
        <div fxFlex class="max-width advance-field-width">
          <lib-text-field-alls #facilityAddress1 [isSubmitted]="isSubmitted" [errorMessage]="facilityAddressOne+isRequired"
            [fullWidth]="true" [fieldLabel]="facilityAddressOne" [placeholder]="'ABCD'" [fieldLength]="100" 
            [fieldName]="facilityAddressOne" [alignmentRight]="false" [required]="true" [formControlData]="vendorRegistrationForm"
            (inputFieldData)="fieldValue($event, 'facilityAddress1')">
          </lib-text-field-alls>
        </div>
      </div>

      <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column">
        <div fxFlex class="max-width advance-field-width">
          <lib-text-field-alls #facilityAddress2 [errorMessage]="facilityAddressTwo+isRequired"
            [fullWidth]="true" [fieldLabel]="facilityAddressTwo" [placeholder]="'ABCD'" [fieldLength]="100" 
            [fieldName]="facilityAddressTwo" [alignmentRight]="false" [required]="false" [formControlData]="vendorRegistrationForm" 
            (inputFieldData)="fieldValue($event, 'facilityAddress2')">
          </lib-text-field-alls>
        </div>
      </div>

      <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column">
        <div fxFlex class="max-width advance-field-width">
          <lib-location-external-autocomplete
            #cityStateCountry searchField [isSubmitted]="isSubmitted" [required]="true" [locationType]="'POSTAL_CODE'" [roleType]="'CITY_STATE_POSTAL'" [showErrors]="true" 
            [placeHolder]="'Search by City or State'" [required]="true" (selectedLocation)="fieldValue($event, 'cityStateCountry')" [locationType]="'POSTAL_CODE'"
            [cityStateCountryText]="true" [showPostalCode]="true">
          </lib-location-external-autocomplete>
        </div>
      </div>

      <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column">
        <div fxFlex class="max-width advance-field-width">
          <lib-text-field-alls #contactName [isSubmitted]="isSubmitted" [errorMessage]="name+isRequired"
            [fullWidth]="true" [fieldLabel]="name" [placeholder]="'ABCD'" [fieldLength]="100" 
            [fieldName]="name" [required]="true" [alignmentRight]="false" [formControlData]="vendorRegistrationForm" 
            (inputFieldData)="fieldValue($event, 'contactName')">
          </lib-text-field-alls>
        </div>

        <div fxFlex class="max-width advance-field-width">
          <lib-phone-validator #phone [fieldLabel]="phoneNumber" [placeholder]="'00000000000'" [isSubmitted]="isSubmitted" (inputFieldData)="fieldValue($event, 'phoneNumber')">
          </lib-phone-validator>
        </div>
      </div>

      <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column">
        <div fxFlex class="max-width advance-field-width">
          <lib-email-validator #email [isSubmitted]="isSubmitted" [fieldLabel]="emailAddress" (inputFieldData)="fieldValue($event, 'email')"></lib-email-validator>
        </div>
      </div>
    </form>

    <div fxLayout="row" class="flex-class" fxLayoutGap="20px" fxLayoutAlign="start start" fxLayout.lt-sm="column">
      <div fxFlex class="max-width advance-field-width">
         <lib-common-comments #comment [commentData]="vendorRegistrationForm.value.comment" [textLength]="500" (commentUpdated)="fieldValue($event, 'comment')"></lib-common-comments>
      </div>
    </div>

    <div [class]="'search-actions-row btns'">
      <up-button button-style="outlined" class="clear-btn" (click)="onClear()" >Clear</up-button>
      <up-button button-style="contained" (click)="saveVendorDetails()">Submit</up-button>
    </div>
  </div>
</div>
